import { matchSelectors } from './_task.match.style.js';
import { DropzoneContainer } from './molecule.dropzones.js';
import { jsx } from 'react/jsx-runtime';

function PrintContainer(props) {
  return /*#__PURE__*/jsx("div", {
    className: matchSelectors.root.className,
    children: /*#__PURE__*/jsx(DropzoneContainer, {
      taskEntryKey: props.taskEntryKey,
      dropzones: props.task.content,
      tiles: props.task.tiles,
      facitType: "user-entry"
    })
  });
}

export { PrintContainer };
//# sourceMappingURL=organism.print-container.js.map
